module.exports = __webpack_public_path__ + "img/aviao.4c55e064.png";